module.exports = __webpack_public_path__ + "img/ghavamin.d86295b7.png";